module.exports = __webpack_public_path__ + "static/media/apartment12.0edf15a5.jpg";